module.exports = __webpack_public_path__ + "static/media/arrow_up.9f5a322a.svg";